var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.982 0.556188L11.4405 1.16369C9.1455 3.74069 5.9595 4.95719 2.1585 5.42069L1.5 5.50019V6.16469C1.5 10.0347 2.319 13.7892 4.014 16.8672C5.709 19.9452 8.31 22.3467 11.7855 23.3832L12.009 23.4507L12.231 23.3742C18.948 21.2037 22.5 14.1327 22.5 6.16469V5.56769L21.9165 5.42969C18.219 4.57769 14.8095 3.54269 12.5445 1.15019L11.982 0.554688V0.556188ZM12.018 2.55119C14.4465 4.81919 17.6355 5.91119 20.9385 6.70019C20.781 13.8717 17.643 19.8537 11.994 21.8232C9.0525 20.8707 6.831 18.8682 5.3295 16.1427C3.8655 13.4877 3.1395 10.1697 3.0615 6.71969C6.534 6.19319 9.6345 4.94969 12.0165 2.55119H12.018Z",
    fill: "#FFC47E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4203 14.7598L11.2174 7.6397C11.2174 7.25032 11.5362 7 12.0145 7C12.4783 7 12.7971 7.25032 12.7826 7.6397L12.5797 14.7598C12.5652 15.0796 12.2899 15.2326 12 15.2326C11.6957 15.2326 11.4203 15.0796 11.4203 14.7598ZM12 16.0809C12.5362 16.0809 13 16.4564 13 17.0405C13 17.6245 12.5362 18 12 18C11.4348 18 11 17.6245 11 17.0405C11 16.4564 11.4348 16.0809 12 16.0809Z",
    fill: "#FFC47E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnHold);
export default __webpack_public_path__ + "static/media/on-hold.afddd9c29c620c21f1766ba803ddcadf.svg";
export { ForwardRef as ReactComponent };